module.exports = __webpack_public_path__ + "static/assets/c5a70a659d7400ca36c753f5ea7afd33.png";